import React, {  useState } from "react";
import ProfileCard from "./components/ProfileCard";
import usePathName from "src/hooks/usePathName";
import { MdMenu } from "react-icons/md";
// import Sidebar from "../sidebar/Sidebar";
// import { Bell } from "lucide-react";
// import { setOnboardingStep, ONBOARDING_STEPS } from "src/onboarding/steps";
// import { startProfileMenuTour } from "src/onboarding/tours"; 


const Header = ({ isSidebarOpen, setIsSidebarOpen }) => {
  const { pathName } = usePathName();
  const userdetails = localStorage.getItem("userDetails");
  const userdata = userdetails ? JSON.parse(userdetails) : {};
  const email = userdata?.email;
  const [isOpen, setIsOpen] = useState(false);
  // const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handletoggle = () => {
        // setOnboardingStep(ONBOARDING_STEPS.PROFILE_PASSKEY);
    setIsOpen((prev) => !prev);
  };

  const handleToggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };


  return (
    <div className="bg-white px-4 py-[9.3px] border-b flex items-center justify-between">
      <p className="font-bold text-sm text-gray-800">{pathName}</p>

      <div className="flex items-center gap-4">
        {/* <button className="relative cursor-pointer group">
          <Bell className="w-5 h-5 text-gray-600 group-hover:text-gray-900 transition" />
          <span className="absolute -top-1 -right-1 w-2 h-2 bg-red-600 rounded-full"></span>
        </button> */}

        {/* <p className='text-sm'>{email}</p> */}
        <button className="md:hidden" onClick={handleToggleSidebar}>
          <MdMenu className="w-5 h-5 text-gray-600" />
        </button>
        {/* {isSidebarOpen && (
          <div className="absolute top-0 left-0 z-50">
            <Sidebar width="full" />
          </div>
        )} */}
      
        <div className="relative hidden md:block">
          <button
          id="header-profile-button"
            onClick={handletoggle}
            onMouseDown={(e) => {
              e.stopPropagation(); // ⬅ stop outside-click listener
            }}
            className="border rounded-md bg-[#E0E7FF] text-[#676CE7] font-semibold py-1 px-2.5 text-sm"
          >
            {email?.charAt(0)?.toUpperCase()}
          </button>
          {isOpen && <ProfileCard onClose={() => setIsOpen(false)} />}
        </div>
      </div>
    </div>
  );
};

export default Header;
